// ============================================================
// Shared API client — used by KingdomConnect.jsx and all
// extracted feature modules (e.g. /components/departments/*).
//
// The Emergent preview iframe wraps window.fetch with telemetry
// that pre-reads the body of non-2xx responses, leaving
// res.json() / res.text() / res.clone() to throw
// "body stream already read". `kcFetch` grabs a clean native
// fetch reference from a hidden same-origin iframe and reuses
// it for every API call.
// ============================================================
export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _nativeFetch = null;
export function kcFetch(input, init) {
  if (!_nativeFetch) {
    if (typeof document !== "undefined") {
      try {
        const ifr = document.createElement("iframe");
        ifr.setAttribute("aria-hidden", "true");
        ifr.style.cssText = "display:none;width:0;height:0;border:0;position:absolute;";
        ifr.srcdoc = "";
        document.documentElement.appendChild(ifr);
        const nf = ifr.contentWindow && ifr.contentWindow.fetch;
        if (typeof nf === "function") _nativeFetch = nf.bind(window);
      } catch (_) { /* fall through to window.fetch */ }
    }
    if (!_nativeFetch) _nativeFetch = window.fetch.bind(window);
  }
  return _nativeFetch(input, init);
}

export function getToken() { return localStorage.getItem("kc_token") || ""; }
export function setToken(t) { if (t) localStorage.setItem("kc_token", t); else localStorage.removeItem("kc_token"); }
export function authHeaders() { const t = getToken(); return t ? { Authorization: `Bearer ${t}` } : {}; }

async function _extractDetail(res) {
  let detail = "Request failed";
  try {
    const j = await res.clone().json();
    if (j && typeof j.detail === "string") detail = j.detail;
  } catch (_) {
    try { const t = await res.clone().text(); if (t) detail = t; } catch (__) { /* nothing */ }
  }
  return detail;
}

export async function _apiPost(path, body) {
  const res = await kcFetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) throw new Error(await _extractDetail(res));
  return res.json();
}
export async function _apiPut(path, body) {
  const res = await kcFetch(`${API_BASE}${path}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeaders() },
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) throw new Error(await _extractDetail(res));
  return res.json();
}
export async function _apiDelete(path) {
  const res = await kcFetch(`${API_BASE}${path}`, { method: "DELETE", headers: { ...authHeaders() } });
  if (!res.ok) throw new Error(await _extractDetail(res));
  return res.json();
}
export async function _apiGet(path) {
  const res = await kcFetch(`${API_BASE}${path}`, { headers: { ...authHeaders() } });
  if (!res.ok) throw new Error(await _extractDetail(res));
  return res.json();
}
